import { render, staticRenderFns } from "./herderList.vue?vue&type=template&id=92ec9b88&scoped=true"
import script from "./herderList.vue?vue&type=script&lang=js"
export * from "./herderList.vue?vue&type=script&lang=js"
import style0 from "./herderList.vue?vue&type=style&index=0&id=92ec9b88&prod&lang=scss&scoped=true"
import style1 from "./herderList.vue?vue&type=style&index=1&id=92ec9b88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92ec9b88",
  null
  
)

export default component.exports